import { BasePage } from 'src/pages/base.page';
import { AppSession } from './AppSession';

export class TratamentoGatewayService {

    context: BasePage

    constructor(context: BasePage) {
        this.context = context
    }

    builder(data: any) {
        if (data === null) {
            this.quebrarSessao()
            throw Error()
        } else {
            return data
        }
    }

    quebrarSessao() {
        AppSession.clearSession()
        this.context.openPage("login")
    }
}